export default function localizeValue(value, lang = null) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  let locale = lang || localStorage.getItem('i18nextLng');
  if (locale !== 'ar') locale = 'en';
  if ('value' in value) return value[locale === 'ar' ? 'value' : 'alt'];
  return value[locale];
}
